import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IStatute } from "../../utils/types/models";

export default createEntityReducer<IStatute>(Endpoint.Statutes, Endpoint.StatutesList);
